const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/intake/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { FullSizeSpinner } from '@/common/components/ui/FullSizeSpinner';
import i18n from '@/common/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/intake')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner,
  staticData: {
    topNav: {
      title: i18n.t($ => $.intake.general.intake)
    }
  },
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.intake.general.intake)
  })
});